<template>
  <div class="phases__phase phase3">
    <div class="phases__phase__header">
      <div class="color-label">
        <div
          class="circle circle-color-label"
          :style="{ backgroundColor: HRN_LEVEL_COLORS[hrnColor1] }"
        ></div>
        <div
          class="circle circle-color-label"
          :style="{ backgroundColor: HRN_LEVEL_COLORS[hrnColor2] }"
        ></div>
      </div>
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="action">
        <slot name="step-link" class="link"></slot>
        <!-- <div class="btn btn-success">Ver</div> -->
      </div>
    </div>
    <div class="phases__phase__body">
      <div class="description">
        <div class="description__title">PONTO FOCAL:</div>
        <div class="description__content">
          <slot name="description"></slot>
        </div>
      </div>
      <div class="status">
        <div class="status__title">STATUS ATUAL</div>
        <div class="status__total">
          Total de situações dessa fase = {{ phaseData.total }}
        </div>
        <div class="status__table">
          <table class="status__table__table table-striped">
            <tbody>
              <tr>
                <td>DELEGADO</td>
                <td>{{ phaseData.delegated || 0 }}</td>
                <td>{{ phaseData.delegatedPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>PROGRAMADO</td>
                <td>{{ phaseData.scheduled || 0 }}</td>
                <td>{{ phaseData.scheduledPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>ORÇADO</td>
                <td>{{ phaseData.budgeted || 0 }}</td>
                <td>{{ phaseData.budgetedPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>PROJETADO</td>
                <td>{{ phaseData.projected || 0 }}</td>
                <td>{{ phaseData.projectedPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>EM ADEQUAÇÃO</td>
                <td>{{ phaseData.inAdequacy || 0 }}</td>
                <td>{{ phaseData.inAdequacyPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>CONCLUÍDO</td>
                <td>{{ phaseData.concluded || 0 }}</td>
                <td>{{ phaseData.concludedPercentage || 0 }} %</td>
              </tr>
              <tr>
                <td>HOMOLOGADO</td>
                <td>{{ phaseData.homologated || 0 }}</td>
                <td>{{ phaseData.homologatedPercentage || 0 }} %</td>
              </tr>
            </tbody>
            <!-- <tfoot v-if="showFooter">
              <tr>
                <td colspan="3">Total previsto em penalidade = R$ {{ '-' }}</td>
              </tr>
            </tfoot> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { HRN_LEVEL_COLORS } from '@/constants/hrn.constants.js'

  export default {
    setup() {
      return {
        HRN_LEVEL_COLORS,
      }
    },
    props: {
      showFooter: {
        type: Boolean,
        required: false,
        default: false,
      },
      hrnColor1: {
        type: Number,
        required: true,
      },
      hrnColor2: {
        type: Number,
        required: true,
      },
      phaseData: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
  }
</script>

<style lang="scss" scoped>
  .phases__phase {
    border-radius: 25px;
    width: 33%;
    min-width: 280px;

    border: 2px solid #383838;

    display: flex;
    flex-direction: column;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-top-left-radius: 20px;
      border-top-right-radius: 20px;

      padding: 15px 20px;

      background-color: #383838;
      color: #fff;

      font-size: 1.2rem;
    }

    &__body {
      padding-top: 5px;

      flex: 1;
      display: flex;
      flex-direction: column;

      .description {
        padding: 0 5px;

        &__title {
        }

        &__content {
          font-size: 0.8rem;
        }
      }

      .status {
        margin-top: 10px;

        flex: 1;
        display: flex;
        flex-direction: column;

        .status__title {
          text-align: center;
        }

        .status__total {
          font-size: 0.8rem;
          padding: 0 5px;
        }

        .status__table {
          font-size: 0.7rem;

          height: 100%;

          &__table {
            width: 100%;
            border-bottom-left-radius: 25px;
            border-bottom-right-radius: 25px;
            overflow: hidden;
            height: 100%;

            tfoot {
              text-align: center;
            }

            tr td {
              padding: 5px 10px !important;
            }
          }
        }
      }
    }
  }

  .color-label {
    display: flex;
    align-items: center;
    justify-content: center;

    .circle {
      border-radius: 50%;
    }

    .circle-color-label {
      width: 20px;
      height: 20px;

      background-color: green;

      &:not(:first-child) {
        margin-left: 5px;
      }
    }
  }
</style>
